import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import {
  msSincePush,
  trackPuzzle,
  trackPuzzleError,
} from '@/Screens/Classroom/utils/puzzleTelemetry';

interface GetActivePuzzlePayload {
  meetingId: string;
  occurenceId: string;
  /** Telemetry only: what caused this fetch. Not sent to the server. */
  trigger?: 'ws_push' | 'mount';
}

export default function useGetActivePuzzleApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<any, unknown, GetActivePuzzlePayload> {
  return useMutation<any, unknown, GetActivePuzzlePayload>(
    async ({trigger, ...payload}: GetActivePuzzlePayload) => {
      const startedAt = Date.now();
      const props = {trigger, ms_since_push_at_start: msSincePush()};
      trackPuzzle('classroom_get_active_puzzle_start', props);
      try {
        const response = await ChessRestClient.post(
          'classroom/v1/get_active_puzzle/',
          payload,
        );
        console.log('Retrieved get_active_puzzle = ', response.data);
        const puzzle = response.data?.active_puzzle;
        trackPuzzle('classroom_get_active_puzzle_done', {
          ...props,
          duration_ms: Date.now() - startedAt,
          has_puzzle: !!puzzle?.puzzle_id,
          puzzle_id: puzzle?.puzzle_id,
          remaining_time: puzzle?.remaining_time,
        });
        return response.data;
      } catch (error: any) {
        trackPuzzleError('classroom_get_active_puzzle_failed', error, {
          ...props,
          duration_ms: Date.now() - startedAt,
          status: error?.response?.status,
          code: error?.code,
        });
        throw error;
      }
    },
    {
      onSuccess: (data: any) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to fetch get_active_puzzle data:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
